/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ProtectedDataPageDialogTypes {
    CdpReplicas = 'CdpReplicas',
}
